import { Box } from '@mui/material';
import { styled } from '@mui/system';

const genericStyles = {
  fontWeight: 400,
  color: '#878787',
};

const InviteStatusWrapper = styled(Box)(() => ({
  fontWeight: 500,
  color: '#181818',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
}));

const ResendInvitationWrapper = styled(Box)(() => ({
  fontWeight: 500,
  fontSize: '14px',
  color: '#181818',
  textTransform: 'none',
}));

const CommonBoxWrapper = styled(Box)(() => ({
  display: 'flex',
  minWidth: '100%',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginBottom: '16px',
}));

const ColonWrapper = styled(Box)(() => ({
  display: 'flex',
  width: '4%',
  color: '#878787',
  justifyContent: 'center',
  alignItems: 'center',
}));

const LabelWrapper = styled(Box)(() => ({
  ...genericStyles,
  fontSize: '14px',
  display: 'flex',
  alignItems: 'center',
}));

const ValueWrapper = styled(Box)(() => ({
  ...genericStyles,
  color: '#181818',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  '& > div': {
    display: 'block',
    wordWrap: 'break-word',
    width: '100%',
  },
}));

export {
  ResendInvitationWrapper,
  LabelWrapper,
  ValueWrapper,
  InviteStatusWrapper,
  ColonWrapper,
  CommonBoxWrapper,
};
